import Reveal from "@/components/Reveal";
import { Star } from "lucide-react";

const TESTIMONIALS = [
  { q: "One growth call changed how we see our brand. The roadmap paid for itself in the first week.", name: "Rohit Malhotra", role: "Founder, D2C Skincare", metric: "3x enquiries in 45 days" },
  { q: "She told us exactly what was broken — no fluff. Our website finally converts.", name: "Ananya Iyer", role: "CEO, Boutique Fashion Label", metric: "2.4x conversion rate" },
  { q: "We were boosting posts blindly. Now every rupee has a funnel behind it.", name: "Vikram Singh", role: "Director, Fitness Studio Chain", metric: "41% lower cost per lead" },
  { q: "The audit alone was worth more than agencies we paid lakhs to.", name: "Priya Nair", role: "Founder, Home Decor Brand", metric: "5x revenue in 6 months" },
  { q: "Clear, sharp, honest. She treats your brand like her own P&L.", name: "Arjun Mehta", role: "Co-founder, SaaS Startup", metric: "0 to 120 demos/month" },
  { q: "Our Instagram finally brings business, not just likes.", name: "Shreya Kapoor", role: "Founder, Bakery & Cafe", metric: "38k to 110k reach" },
  { q: "From confused positioning to a brand people remember. Best ₹999 we ever spent.", name: "Daniel D'Souza", role: "Founder, Men's Grooming", metric: "Sold out 2 launches" },
  { q: "Strategy, design, execution — one person, zero excuses. Rare.", name: "Meera Krishnan", role: "MD, Jewellery House", metric: "4.9x ROAS on festive ads" },
];

const Card = ({ t }) => (
  <div className="hover-card-glow w-[320px] sm:w-[400px] shrink-0 mx-3 rounded-2xl border border-[#27331C] bg-[#0E140A] p-6 sm:p-7">
    <div className="flex gap-1 mb-4">
      {[...Array(5)].map((_, i) => (
        <Star key={i} className="w-3.5 h-3.5 fill-[var(--accent)] text-[var(--accent)]" />
      ))}
    </div>
    <p className="text-sm sm:text-base text-[#F2F1E8] leading-relaxed">"{t.q}"</p>
    <div className="mt-5 flex items-end justify-between gap-3">
      <div>
        <p className="text-sm font-semibold text-[#F2F1E8]">{t.name}</p>
        <p className="text-xs text-[#8A8C7E] mt-0.5">{t.role}</p>
      </div>
      <span className="shrink-0 font-mono2 text-[9px] tracking-[0.15em] text-[var(--accent)] border border-[var(--accent)]/30 rounded-full px-3 py-1.5">
        {t.metric}
      </span>
    </div>
  </div>
);

const Testimonials = () => {
  const rowA = TESTIMONIALS.slice(0, 4);
  const rowB = TESTIMONIALS.slice(4);
  return (
    <section data-testid="testimonials-section" className="relative py-24 sm:py-32 overflow-hidden">
      <Reveal className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-baseline gap-4 mb-6">
          <span className="font-mono2 text-xs tracking-[0.3em] text-[var(--accent)]">CLIENT LOVE</span>
          <span className="h-px flex-1 bg-[#27331C]" />
          <span className="font-mono2 text-xs tracking-[0.3em] text-[#8A8C7E]">5000+ BRANDS STRONG</span>
        </div>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-[#F2F1E8] max-w-3xl">
          Don't take my word for it.<br />
          <span className="italic text-[var(--accent)]">Take theirs.</span>
        </h2>
      </Reveal>

      <div className="mt-14 space-y-6 marquee-pause" data-testid="testimonials-wall">
        <div className="flex w-max animate-marquee">
          {[0, 1].map((half) => (
            <div key={half} className="flex shrink-0">
              {rowA.map((t, i) => <Card key={`${half}-a-${i}`} t={t} />)}
            </div>
          ))}
        </div>
        <div className="flex w-max animate-marquee-reverse">
          {[0, 1].map((half) => (
            <div key={half} className="flex shrink-0">
              {rowB.map((t, i) => <Card key={`${half}-b-${i}`} t={t} />)}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
